import React from "react";
import { getViewer } from "types/gql-types";

const Context = React.createContext<getViewer["viewer"]>(null);
Context.displayName = "ViewerPostgres";

export const Login = React.createContext({ onLogin: () => {} });


export const usePostgresViewer = () => {
  const context = React.useContext(Context);
  // eslint-disable-next-line no-undefined
  if (context === undefined) {
    throw new Error("usePostgresViewer must be used within a ViewerProvider");
  }
  return context;
};

export default Context;
